import { SCOPE as ADMIN_SCOPE } from '../types';

export const SCOPE = 'apps';
export const LIST = `${ADMIN_SCOPE}/${SCOPE}/LIST`;
export const LIST_DONE = `${ADMIN_SCOPE}/${SCOPE}/LIST_DONE`;
export const CREATE = `${ADMIN_SCOPE}/${SCOPE}/CREATE`;
export const CREATE_DONE = `${ADMIN_SCOPE}/${SCOPE}/CREATE_DONE`;
export const UPDATE = `${ADMIN_SCOPE}/${SCOPE}/UPDATE`;
export const UPDATE_DONE = `${ADMIN_SCOPE}/${SCOPE}/UPDATE_DONE`;
export const DELETE = `${ADMIN_SCOPE}/${SCOPE}/DELETE`;
export const DELETE_DONE = `${ADMIN_SCOPE}/${SCOPE}/DELETE_DONE`;
